import { GameScene } from "../scenes/GameScene";
import { LTGame } from "./LTGame";

export class GameState {

	game: LTGame;
	scene: GameScene;

	constructor(game: LTGame, scene: GameScene) {
		this.game = game;
		this.scene = scene;
	}

	start(): void {
		return;
	}

	update(dt: number): void {
		return;
	}

	onPassedWallMidpoint(): void {
		return;
	}

	shutdown(): void {
		return;
	}

}